<template>
  <!-- <teleport to="body"> -->
    <div class="bulk-toast-container">
      <transition-group name="toast-slide">
        <div
          v-for="(log, logIndex) in logs"
          :key="log.createdAt + logIndex"
          :class="['bulk-toast', `bulk-toast--${log.status}`]"
          class="mb-2"
        >
          <!-- Toast Header -->
          <div class="bulk-toast-header">
            <div class="d-flex align-items-center" style="gap: 8px;">
              <i :class="['bulk-toast-icon', statusConfig[log.status].icon]"></i>
              <div>
                <div class="bulk-toast-title">{{ log.label }}</div>
                <div class="bulk-toast-subtitle">Diproses pada: {{ formatDateTime(log.createdAt) }}</div>
              </div>
            </div>
            <div class="d-flex align-items-center" style="gap: 4px;">
              <button class="bulk-toast-btn" @click="toggleCollapse(logIndex)">
                 <img
                    src="~@/assets/icon/arrow-down.png"
                    style="width: 10px"
                    v-if="collapsed[logIndex]"
                />
                <img
                  src="~@/assets/icon/arrow-up.png"
                  style="width: 10px"
                  v-else
                />
                <!-- <i :class="collapsed[logIndex] ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i> -->
              </button>
              <button v-if="log.status !== 'process'" class="bulk-toast-btn" @click="$emit('dismiss', logIndex)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <!-- Toast Items -->
          <transition name="collapse">
            <div v-if="!collapsed[logIndex]" class="bulk-toast-items">
              <div
                v-for="(item, itemIndex) in log.bulkItems"
                :key="itemIndex"
                class="bulk-toast-item"
              >
                <span class="bulk-toast-dot" :style="{ background: statusConfig[log.status].dotColor }"></span>
                <span class="bulk-toast-company">{{ log.companyName }}</span>
                <span class="bulk-toast-sep" :style="{ color: statusConfig[log.status].dotColor }">•</span>
                <span class="bulk-toast-text">Order ID: {{ item.orderCode }}</span>
                <span class="bulk-toast-sep" :style="{ color: statusConfig[log.status].dotColor }">•</span>
                <span class="bulk-toast-text">Dari: {{ formatDateRange(item.startDate) }} - {{ formatDateRange(item.endDate) }}</span>
              </div>
            </div>
          </transition>
        </div>
      </transition-group>
    </div>
  <!-- </teleport> -->
</template>

<script>
import moment from 'moment'

export default {
  name: 'BulkCreationLogBanner',
  props: {
    logs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      collapsed: {},
      statusConfig: {
        process: {
          icon: 'fas fa-exclamation-triangle',
          dotColor: '#F5A623',
        },
        success: {
          icon: 'fas fa-check-circle',
          dotColor: '#28A745',
        },
        failed: {
          icon: 'fas fa-times-circle',
          dotColor: '#DC3545',
        },
      }
    }
  },
  watch: {
    logs: {
      immediate: true,
      handler(newLogs) {
        newLogs.forEach((_, i) => {
          if (this.collapsed[i] === undefined) {
            this.$set(this.collapsed, i, false)
          }
        })
      }
    }
  },
  methods: {
    toggleCollapse(index) {
      this.$set(this.collapsed, index, !this.collapsed[index])
    },
    formatDateTime(value) {
      return moment(value).format('D MMM YYYY HH.mm')
    },
    formatDateRange(value) {
      return moment(value).format('MMMM YYYY')
    },
  }
}
</script>

<style scoped>
/* ── Container: fixed top-right ── */
/* .bulk-toast-container {
  position: fixed;
  top: 70px;
  right: 24px;
  left: 50%;
  z-index: 1055;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 65%;
  max-width: calc(100vw - 48px);
  pointer-events: none;
  transform: translateX(-35%);
} */
.bulk-toast-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}

/* ── Each toast ── */
.bulk-toast {
  border-radius: 10px;
  padding: 14px 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  /* pointer-events: all; */
}

.bulk-toast--process {
  background-color: #FFFBF0;
  border: 1px solid #F5C842;
}
.bulk-toast--process .bulk-toast-icon { color: #F5A623; }

.bulk-toast--success {
  background-color: #F0FFF4;
  border: 1px solid #68D391;
}
.bulk-toast--success .bulk-toast-icon { color: #28A745; }

.bulk-toast--failed {
  background-color: #FFF5F5;
  border: 1px solid #FC8181;
}
.bulk-toast--failed .bulk-toast-icon { color: #DC3545; }

/* ── Header ── */
.bulk-toast-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.bulk-toast-icon {
  font-size: 17px;
  margin-top: 2px;
  flex-shrink: 0;
}

.bulk-toast-title {
  font-size: 13px;
  font-weight: 600;
  color: #2E3646;
  line-height: 1.4;
}

.bulk-toast-subtitle {
  font-size: 11px;
  color: #8A94A6;
  margin-top: 2px;
}

.bulk-toast-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #8A94A6;
  font-size: 13px;
  padding: 2px 5px;
  line-height: 1;
  transition: color 0.15s;
  border-radius: 4px;
}
.bulk-toast-btn:hover {
  color: #2E3646;
  background: rgba(0,0,0,0.05);
}

/* ── Items ── */
.bulk-toast-items {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding-left: 24px;
  overflow: hidden;
}

.bulk-toast-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  font-size: 12px;
  color: #2E3646;
}

.bulk-toast-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.bulk-toast-company {
  font-weight: 600;
  color: #2E3646;
}

.bulk-toast-sep {
  font-weight: bold;
}

.bulk-toast-text {
  color: #4A5568;
}

/* ── Transitions ── */
.toast-slide-enter-active,
.toast-slide-leave-active {
  transition: all 0.3s ease;
}
.toast-slide-enter,
.toast-slide-leave-to {
  opacity: 0;
  transform: translateX(40px);
}

.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.25s ease;
  max-height: 300px;
}
.collapse-enter,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/BulkCreationLogBanner.vue